"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _school = require("@/api/school/school");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "作品/课程名称",
        prop: "workName",
        isShow: true,
        width: "200"
      }, {
        name: "选手名称",
        prop: "userName",
        isShow: true,
        width: "200"
      }],
      funBtns: [
      // {
      //   size: "small",
      //   click: "exportList",
      //   icon: "el-icon-download",
      //   name: "导出作品清单",
      //   type: "primary"
      // },
      {
        size: "small",
        click: "addWorks",
        icon: "el-icon-circle-plus-outline",
        name: "新增",
        type: "primary"
      }, {
        size: "small",
        click: "delWork",
        icon: "el-icon-delete",
        name: "批量删除",
        type: "danger"
      }],
      minWidth: 300,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      options: [{
        name: " 编辑",
        class: "edit",
        option: "edit",
        span: 2
      }, {
        name: " 删除",
        class: "edit",
        option: "delWork",
        span: 2
      }
      // {
      //   name: " 提交作品",
      //   class: "editor",
      //   option: "submitWorks",
      //   span: 4,
      //   isFuntion: true,
      //   optionFun: "cszpPd"
      // }
      ],
      formatters: {
        belongAdministrator: []
      },
      sort: {
        prop: "",
        order: ""
      },
      expertId: "",
      addList: [],
      catalogueDia: false,
      addForm: {},
      checkBoxs: [],
      editDia: false,
      editList: [],
      editForm: {}
    };
  },
  methods: {
    // 导出作品清单
    exportList: function exportList() {
      var _this = this;
      (0, _school.exportWorkList)({
        id: this.$route.query.id,
        keyWords: "",
        pageNum: 1,
        pageSize: 999
      }).then(function (res) {
        _this.commonJs.download(res, "作品清单.xlsx");
      });
    },
    // 编辑
    edit: function edit(e) {
      var _this2 = this;
      (0, _school.workRule)({
        matchId: this.$route.query.id,
        batchId: e.id
      }).then(function (res) {
        console.log(res, "sasa");
        _this2.editList = res.data;
      });
      this.editDia = true;
    },
    // 编辑后提交
    editSubmit: function editSubmit() {
      var _this3 = this;
      (0, _school.editSubmit)(this.editList).then(function (res) {
        _this3.editDia = false;
        _this3.getWorksList();
      });
    },
    // 删除
    delWork: function delWork(row) {
      var _this4 = this;
      var id = [];
      if (!row && this.checkBoxs.length === 0) {
        return this.$message.error("请先勾选数据，再进行操作。");
      } else if (row) {
        id.push(row.id);
      } else if (this.checkBoxs.length > 0) {
        id = this.checkBoxs;
      }
      this.$confirm("确认删除吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(function () {
        (0, _school.delWorkList)({
          idList: id
        }).then(function () {
          _this4.getWorksList();
          _this4.$message.success("操作成功。");
        });
      }).catch(function () {
        _this4.$message.info("取消删除。");
      });
    },
    // 新增作品清单数据
    submitWorkList: function submitWorkList() {
      var _this5 = this;
      (0, _school.insetWorkList)(this.addList).then(function (res) {
        if (res.code === 2000) {
          _this5.$message.success("操作成功。");
          _this5.getWorksList();
          _this5.catalogueDia = false;
        }
      });
    },
    // 获取新增规则
    getNewRule: function getNewRule() {
      var _this6 = this;
      (0, _school.workRule)({
        matchId: this.$route.query.id,
        batchId: ""
      }).then(function (res) {
        _this6.addList = res.data;
      });
    },
    // 获取清单列表
    getWorksList: function getWorksList() {
      var _this7 = this;
      (0, _school.getWorksList)({
        id: this.$route.query.id,
        keyWords: "",
        pageNum: this.page.pageNumber,
        pageSize: this.page.pageSize
      }).then(function (res) {
        var data = res.data;
        _this7.totalData = data.total;
        _this7.listData = data.list;
      });
    },
    cszpPd: function cszpPd(row, callback) {
      if (row.workStatus == -1 || row.workStatus == 0 || row.workStatus == 2) {
        callback(true);
      } else {
        callback(false);
      }
    },
    // 获取作品清单规则
    worksCatalogue: function worksCatalogue() {
      var _this8 = this;
      (0, _school.worksCatalogue)({
        matchId: this.$route.query.id
      }).then(function (res) {
        var data = res.data;
        if (data.length > 0) {
          _this8.defaultColumn = data;
          _this8.defaultColumn.forEach(function (item) {
            item.width = "120";
            item.prop = item.name;
            item.isShow = true;
          });
        }
      });
    },
    // 学校填写作品清单
    addWorks: function addWorks() {
      this.getNewRule();
      this.catalogueDia = true;
    },
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getWorksList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageNumber = 1;
      this.page.pageSize = e;
      this.getWorksList();
    },
    handleSelectionChange: function handleSelectionChange(e) {
      var _this9 = this;
      this.checkBoxs = [];
      e.forEach(function (item) {
        _this9.checkBoxs.push(item.id);
      });
    }
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  },
  created: function created() {
    this.worksCatalogue();
    this.getWorksList();
  }
};